import { usePermissionContext } from "@src/modules/member/context/permission-context/hook";

export function usePermissions() {
  return usePermissionContext();
}

export function useHasPermission(slug: string): boolean {
  const { permissions } = usePermissionContext();
  return permissions.includes(slug);
}

export function useHasAnyPermission(slugs: string[]): boolean {
  const { permissions } = usePermissionContext();
  return slugs.some((slug) => permissions.includes(slug));
}

export function useHasAllPermissions(slugs: string[]): boolean {
  const { permissions } = usePermissionContext();
  return slugs.every((slug) => permissions.includes(slug));
}
